import React from 'react';
import { Modal, Box, SpaceBetween, Button, Alert } from "@cloudscape-design/components";
import { formatDateRangeForModal } from '../../utils/insights/dateFormatters';
import { canConfirmSummary, verificationLines } from '../../utils/insights/verificationSummary';

/**
 * Formatea supervisor para el modal
 */
function formatSupervisorForModal(supervisor, t) {
  if (!supervisor) {
    return t("insights.all");
  }
  return supervisor;
}

/**
 * Formatea agentes para el modal
 */
function formatAgentsForModal(agents, t) {
  if (!agents || agents.length === 0) {
    return t("insights.all");
  }
  return agents.join(", ");
}

/**
 * Modal de confirmación para procesar resumen
 */
export default function ConfirmationModal({
  visible,
  onDismiss,
  onConfirm,
  summaryName,
  dateRange,
  selectedSupervisor,
  selectedAgents,
  verificationResult,
  generatingSummary,
  t
}) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t("insights.summaryConfirmation")}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button 
              onClick={onDismiss} 
              variant="link"
            >
              {t("insights.cancel")}
            </Button>
            <Button 
              onClick={onConfirm} 
              variant="primary"
              loading={generatingSummary}
              disabled={!canConfirmSummary(verificationResult)}
            >
              {t("insights.createSummary")}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="xs">
        {/* Bloque de resumen (4 líneas compactas) */}
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <div>
            <strong>Nombre:</strong> {summaryName || "-"}
          </div>
          <div>
            <strong>Rango de fechas:</strong> {formatDateRangeForModal(dateRange)}
          </div>
          <div>
            <strong>Supervisor:</strong> {formatSupervisorForModal(selectedSupervisor, t)}
          </div>
          <div>
            <strong>Agentes:</strong> {formatAgentsForModal(selectedAgents, t)}
          </div>
        </div>

        {/* Callout informativo */}
        {verificationResult && (
          <Alert type="info">
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <div>
                <strong>{t("insights.callsToProcess")}</strong>
              </div>
              {/* feature 025 (FR-042, T093): registros, con análisis, a analizar y operaciones */}
              {verificationLines(verificationResult, t).map((line) => (
                <div key={line}>{line}</div>
              ))}
              {verificationResult.estimated_tokens && (
                <div>
                  <Button variant="link" style={{ padding: 0, fontSize: "inherit" }}>
                    (~{verificationResult.estimated_tokens} {t("insights.tokens")})
                  </Button>
                </div>
              )}
            </div>
          </Alert>
        )}
      </SpaceBetween>
    </Modal>
  );
}

